<template>
    <nav
        class="bg-white px-4 py-3 flex items-center justify-between sm:px-6"
        aria-label="Pagination"
    >
        <div class="hidden sm:block">
            <p class="text-sm text-gray-700">
                Showing
                {{ " " }}
                <span class="font-medium">{{ meta?.first ?? meta.from }}</span>
                {{ " " }}
                to
                {{ " " }}
                <span class="font-medium">{{ meta?.last ?? meta.to }}</span>
                {{ " " }}
                of
                {{ " " }}
                <span class="font-medium">{{ meta.total }}</span>
                {{ " " }}
                results
            </p>
        </div>
        <div
            class="flex-1 flex justify-between sm:justify-end"
        >
            <button
                v-if="meta.prev"
                @click="$emit('prev')"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
                Previous
            </button>
            <button
                v-if="meta.next"
                @click="$emit('next')"
                class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
                Next
            </button>
        </div>
    </nav>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        meta: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>

</style>
